import React, { Component } from 'react';
import Select from 'react-select';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';

import { EstPorSeccion, UploadXls } from '../../../funciones/CalifFunction';
import { ConsultaCortes } from '../../../funciones/CalifDirFunction';
import EstudiantesTableCalifDir from "./EstudiantesTableCalifDir";

class EditCalif extends Component {
    state = {
        valorCorte: { value: '', label: '- Selecciona un Corte -' },
        cortes: [{ value: '', label: ' - Cargando - ', codigo: '' }],
        preloaderCorte: "",
        estudiantes: [],
        boton1: {
            Icon: "fa fa-upload",
            Title: "Subir Archivo xls"
        },
        detalles: {
            class: "custom-alert-warning",
            title: <strong>Detalles de la Sección</strong>
        },
        estErr: []
    }

    constructor (props) {
        super (props);

        ConsultaCortes ((resp) => {
            this.setState({
                cortes: resp
            })
        })
    }

    ayuda = () => (
        <React.Fragment>
            <Row>
                <Col md={12}>
                    <strong style={{color:"#1f2f6e"}}>Paso 1:</strong>
                </Col>
                <Col md={12} align="justify">
                    <div>Selecciona <strong>Un Corte</strong> disponible.</div>
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    <div style={{fontSize:10}}><strong>Importante: La calificación del corte de notas debe hacerse en la escala correspondiente sin tomar en cuenta el porcentaje equivalente de dicho corte.</strong></div>
                    <div style={{fontSize:10}}><strong>Si la calificación corresponde del 1 al 20 se debe colocar la calificación obtenida. Por Ejemplo: 14</strong></div>
                </Col>

                <Col md={12} className="custom-mt-10">
                        <strong style={{color:"#1f2f6e"}}>Paso 2:</strong>
                </Col>
                <Col md={12} align="justify">
                    <div>
                        Una vez seleccionados el corte y la sección, asegúrate que son los correctos mediante la opción <span className="custom-alert-warning"><strong>Detalles de la Sección</strong></span> antes de continuar
                    </div>
                </Col>

                <Col md={12} className="custom-mt-10">
                        <strong style={{color:"#1f2f6e"}}>Paso 3:</strong>
                </Col>
                <Col md={12} align="justify">
                    <div>En este punto pordrás ver el listado de estudiantes correspondientes a la sección y en la parte derecha de cada estudiante un <strong>Cuadro de Texto</strong> donde podrás colocar la calificación.</div>
                </Col>

                <Col md={12} className="custom-mt-10">
                        <strong style={{color:"#1f2f6e"}}>Paso 4:</strong>
                </Col>
                <Col md={12} align="justify">
                    <div>Para cambiar la calificación simplemente haz click en el <strong>Cuadro de Texto</strong>, ingresa una calificación válida y espera que el icono de la derecha cambie de <i className="fa fa-circle-o-notch fa-spin"></i> a:</div>
                    <div className="custom-mt-10"><i className="fa fa-check" style={{color:"#32704C"}}></i>: Indica que la calificación se almacenó correctamente.</div>
                    <div className="custom-mt-10"><i className="fa fa-times" style={{color:"#A0555C"}}></i>: Indica que ocurrió un problema con la calificación, en este caso debes volver a ingresar una calificación válida.</div>
                    <div className="custom-mt-10" style={{fontSize:10}}><strong>Tip:</strong> Para avanzar entre una calificación y otra presiona la tela Enter.</div>
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col md={12}>
                    <strong style={{color:"#1f2f6e"}}>El botón</strong> <button className="btn btn-primary btn-xs" style={{borderWidth:1, backgroundColor: "#4aa5a5", borderColor: "#4aa5a5", color:"#FFF"}}><i className="fa fa-upload"></i> Subir Archivo xls</button>
                </Col>

                <Col md={12} align="justify" className="custom-mt-10">
                    <div>Permite adjuntar el archivo de calificaciones (proporcionado por el sistema) para cargar las calificaciones correspondientes a la materia y el corte seleccionados.</div>
                    <div className="custom-mt-10">Para eso simplemente haz <strong>click</strong> en el botón y selecciona el documento .xls que contiene las calificaciones de la sección.</div>
                    <div className="custom-mt-10">Luego de eso el sistema analizará las calificaciones y serán actualizadas <strong style={{color:"#1f2f6e"}}>automáticamente.</strong></div>
                    <div className="custom-mt-10">En caso de que alguna calificación no se actualice, el sistema te notificará indicando el o los estudiantes que tienen algún error.</div>
                </Col>
            </Row>
        </React.Fragment>
    )

    valorCorte = (valorCorte) => {
        let { seccion } = this.props;

        this.setState({
            preloaderCorte: "fa fa-spinner fa-spin",
            boton1: {
                Icon: "fa fa-upload",
                Title: "Subir Archivo xls"
            },
            detalles: {
                class: "custom-alert-warning",
                title: <strong>Detalles de la Sección</strong>
            },
        }, () => {
            if (seccion.sec === ""){
                this.setState({
                    valorCorte,
                    preloaderCorte: ""
                })
            }else{
                EstPorSeccion(seccion.sec, (resp) => {
                    this.setState({
                        estudiantes: resp[0],
                        valorCorte,
                        preloaderCorte: ""
                    })
                })
            }
        })
    }

    uploadFile = () => (e) => {
        let { seccion } = this.props;
        let { valorCorte } = this.state;
        let archivo = document.getElementById("upXls").value;
        let extension = archivo.split('.').pop();
        let ext = extension.toLowerCase();

        if (archivo === ""){ toast.error("No has seleccionado ningún archivo",{autoClose: 4000}); return null }
        if (ext !== "xls"){
            toast.error("No has seleccionado un archivo .xls",{autoClose: 4000});
            document.getElementById("upXls").value = "";
            return null
        }

        this.setState ({
            boton1: {
                Icon: "fa fa-spinner fa-spin",
                Title: "Subiendo el archivo"
            }
        }, () => {
            UploadXls(document.getElementById("upXls"), seccion.sec, valorCorte.value, (resp)=> {
                let data = JSON.parse(resp);
                let nameErrores = data.est;
                let contentErr = [];
                let ciErr = [];

                for (let i in nameErrores) {
                    if (nameErrores[i] !== "") contentErr.push(
                        <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i].est}</div>
                    )
                }

                for (let i in nameErrores) {
                    ciErr.push(nameErrores[i].estCi)
                }

                let erroresList = (
                    <Popover bsSize="large" title="Calificaciones No Agregadas" id="erroresList">
                        {contentErr}
                    </Popover>
                )

                if (data.errores > 0) {
                    this.setState({
                        detalles: {
                            class: "custom-alert-danger",
                            title:  <div>
                                        Se han encontrado {data.errores} error(es). Haz click <span>
                                        <OverlayTrigger trigger="focus" placement="bottom" overlay={erroresList}>
                                            <button style={{borderWidth: 1, backgroundColor:"#b41806", color: "#FFF"}} className="btn btn-danger btn-xs">Aqui</button> 
                                        </OverlayTrigger></span> para verlos
                                    </div>
                        },
                        estErr: ciErr
                    })
                }else{
                    this.setState({
                        detalles: {
                            class: "custom-alert-warning",
                            title: <strong>Detalles de la Sección</strong>
                        }
                    })
                }

                toast[data.status](data.mess,{autoClose: 6000});
                this.setState({
                    boton1: {
                        Icon: "fa fa-upload",
                        Title: "Subir Archivo xls"
                    }
                }, () => {
                    document.getElementById("upXls").value = "";
                    EstPorSeccion(seccion.sec, (resp) => {
                        this.setState({
                            estudiantes: resp[0]
                        })
                    })
                })
            })
        })
    }

    selectFile = () => (e) => {
        document.getElementById("upXls").click();
    }

    render() {
        let { cortes, valorCorte, estudiantes, preloaderCorte } = this.state;
        let { seccion, literales } = this.props;

        const styles = {
            padding: 5, fontSize: 12
        }

        let help1 = (
            <Popover title={<div align="center"><i className="fa fa-question-circle-o"></i> <strong>Editar Calificaciones</strong></div>} id="ins" style={{overflowY:"auto", height:"70vh"}}>
                {this.ayuda()}
            </Popover>
        )

        let estudiants = () => {
            let { estErr } = this.state;
            if (valorCorte.value === "") {
                return (
                    <tr>
                        <td colSpan={5} align= "center" style={{padding: 5, fontSize: 12}}>
                            Selecciona el Corte de Notas a cargar calificaciones
                        </td>
                    </tr>
                )
            }else{
                if(estudiantes.length === 0){
                    return (
                        <tr>
                            <td colSpan={5} align= "center" style={{padding: 5, fontSize: 12}}>
                                No existen estudiantes en esta sección
                            </td>
                        </tr>
                    )
                }

                let num = 1
                let numero = () => { return num ++; }

                let num2 = 1
                let numero2 = () => { return num2 ++; }

                let lit = () => {
                    if (seccion.cuantitativo === 1) return null;
                    return literales
                }

                return (
                    estudiantes.map(option => (
                        <EstudiantesTableCalifDir 
                            key={ `est_${numero2()}` }
                            num = { numero() }
                            est = { option }
                            corte = { valorCorte.value }
                            seccion = { seccion.sec }
                            estErr = { estErr }
                            cuantitativo = {seccion.cuantitativo}
                            literales = {lit()}
                        />
                    ))
                )
            }
        }

        let noDown = (
            <Popover bsSize="large" title="No puedes realizar este proceso" id="Inscrito">
                <div className="custom-alert-danger">¿No puedes importar la calificacion?</div>
                <div className="custom-mt-10"><strong>Tal vez se deba a dos razones:</strong></div>
                <div className="custom-mt-10">
                    <Row>
                        <Col md={2} align="center"><strong>1</strong></Col>
                        <Col md={10} align="justify">
                            Es posible que la sección que seleccionaste no posea ningún estudiante inscrito
                        </Col>
                    </Row>
                </div>
                <div align="justify" className="custom-mt-10">
                    <Row>
                        <Col md={2} align="center"><strong>2</strong></Col>
                        <Col md={10} align="justify">
                            No has seleccionado el corte a importar
                        </Col>
                    </Row>
                </div>
            </Popover>
        )

        let boton = () => {
            let { boton1 } = this.state;
            if (this.state.estudiantes.length > 0){
                return(
                    <React.Fragment>
                        <button className="btn btn-success" onClick={this.selectFile()} style={{borderWidth:1, backgroundColor: "#4aa5a5", borderColor: "#4aa5a5", color:"#FFF"}} title="Importar calificaciones a partir de la hoja de cálculo generada por el sistema"><i className={boton1.Icon}></i> {boton1.Title}</button>
                        <input type="file" id="upXls" onChange= {this.uploadFile()} className="form-control" style={{ display: "none"}}/>
                    </React.Fragment>
                )
            }else{
                return(
                    <OverlayTrigger trigger="focus" placement="left" overlay={noDown}>
                        <button className="btn btn-success" style={{borderWidth:1, backgroundColor: "#4aa5a5", borderColor: "#4aa5a5", color:"#FFF"}} title="Importar calificaciones a partir de la hoja de cálculo generada por el sistema"><i className={boton1.Icon}></i> {boton1.Title}</button>
                    </OverlayTrigger>
                )
            }
        }

        let detalles = () => {
            let { detalles } = this.state;

            let corte = () => {
                if (valorCorte.value === "") return "No Seleccionado"
                return valorCorte.label;
            }

            return (
                <React.Fragment>
                    
                    <Row className="custom-mt-10">
                        <Col md={8}>
                            <div className={detalles.class} style={{paddingTop: 8, paddingBottom: 8, paddingLeft: 5, paddingRight: 5}}>
                                <span>{detalles.title}</span>
                            </div>  
                        </Col>
                        <Col md={4} align="right">
                            {boton()}
                        </Col>
                    </Row>
                    
                    <Row className="custom-mt-10">
                        <Col md={3} style={{fontSize:10}}>
                            <span className="text-danger">Carrera</span>
                        </Col>
                        <Col md={2} style={{fontSize:10}}>
                            <span className="text-danger">Semestre</span>
                        </Col>
                        <Col md={5} style={{fontSize:10}}>
                            <span className="text-danger">Sección</span>
                        </Col>
                        <Col md={2} style={{fontSize:10}}>
                            <span className="text-danger">Corte</span>
                        </Col>

                        <Col md={3} style={{fontSize:10}}>
                            <span className="text-muted">{seccion.carrera}</span>
                        </Col>
                        <Col md={2} style={{fontSize:10}}>
                            <span className="text-muted">{seccion.semestre}</span>
                        </Col>
                        <Col md={5} style={{fontSize:10}}>
                            <span className="text-muted">{seccion.materia} - {seccion.nombre}</span>
                        </Col>
                        <Col md={2} style={{fontSize:10}}>
                            <span className="text-muted">{corte()}</span>
                        </Col>
                    </Row>
                </React.Fragment>
            )
        }
        
        return (
            <div className="content">
                <Row>
                    <Col md={11}>
                        <div className="custom-alert-info" style={{padding:5}}>
                            <Row>
                                <Col md={7}>
                                    <span>Sección Seleccionada</span>
                                    <div><strong>{seccion.carrera} - {seccion.semestre}</strong></div>
                                    <div className="text-danger"><strong>{seccion.materia} - {seccion.nombre}</strong></div>
                                </Col>
                                <Col md={5}>
                                    <span>Selecciona un Corte <i className={preloaderCorte}></i></span>
                                    <Select
                                        isSearchable ={true}
                                        value={valorCorte}
                                        onChange={this.valorCorte}
                                        options={cortes}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col md={1} align="right">
                        <OverlayTrigger trigger="focus" placement="bottom" overlay={help1}>
                            <button className="btn btn-warning" title="Ver Ayuda" style={{borderWidth: 1, marginTop:5}}><i className="fa fa-question-circle-o"></i></button>
                        </OverlayTrigger>
                    </Col>
                    <Col md={12}>
                        {detalles()}
                        <div className="table-responsive custom-mt-10" style={{height: "45vh", overflowY: "auto", overflowX:"hidden"}}>
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td width="80%" colSpan={3} style={styles}><strong>Estudiantes</strong></td>
                                        <td width="20%" colSpan={2} style={styles} align= "center"><strong>Calificación</strong></td>
                                    </tr>
                                    {estudiants()}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default EditCalif;


// WEBPACK FOOTER //
// ./src/views/Academicos/CalificacionesContent/EditCalif.jsx